import React from 'react';

const features = [
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    title: 'Faces that match your day',
    description: 'Categorised by mood, activity, and time of day. Crisp typography, vivid complications, and colour stories that adapt to Focus mode.',
    pills: ['Work-ready', 'Fitness-driven', 'Sleep-friendly'],
    accent: 'rgba(104,193,174,0.12)',
    accentBorder: 'rgba(104,193,174,0.25)',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    title: 'Animated Always-On Wallpapers',
    description: 'Looping gradients and minimal motion scenes optimised for Smart Watch battery life and glanceability.',
    pills: ['Seasonal packs', 'Minimal gradients', 'Creator exclusives'],
    accent: 'rgba(168,120,220,0.10)',
    accentBorder: 'rgba(168,120,220,0.2)',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
    title: 'Smart Widget Stacks',
    description: 'Complications that update with your calendar, weather, and activity rings — zero manual tweaking required.',
    pills: ['Live calendar', 'Focus-aware', 'Weather + fitness'],
    accent: 'rgba(240,197,110,0.10)',
    accentBorder: 'rgba(240,197,110,0.2)',
  },
];

const Showcase: React.FC = () => {
  return (
    <section
      id="features"
      className="py-28"
      style={{ background: '#080C0B' }}
    >
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="section-badge mb-4 inline-flex">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#68C1AE]" />
            What's inside
          </span>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight" style={{ letterSpacing: '-0.03em' }}>
            The most expressive<br />
            <span className="gradient-text">Smart Watch</span> setups.
          </h2>
          <p className="mt-5 text-lg text-white/45 max-w-2xl mx-auto leading-relaxed">
            Every drop goes through visual QA on real hardware, so your wrist always looks intentional.
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-5 md:grid-cols-3">
          {features.map((f, i) => (
            <article
              key={i}
              className="relative rounded-3xl p-7 hover-lift overflow-hidden"
              style={{
                background: `radial-gradient(120% 100% at 0% 0%, ${f.accent} 0%, rgba(255,255,255,0.02) 100%)`,
                border: `1px solid ${f.accentBorder}`,
              }}
            >
              {/* Icon */}
              <div
                className="w-11 h-11 rounded-2xl flex items-center justify-center mb-5"
                style={{ background: f.accent, border: `1px solid ${f.accentBorder}`, color: '#68C1AE' }}
              >
                {f.icon}
              </div>

              <h3 className="text-xl font-bold text-white leading-snug" style={{ letterSpacing: '-0.02em' }}>{f.title}</h3>
              <p className="mt-3 text-[15px] text-white/50 leading-relaxed">{f.description}</p>

              {/* Pills */}
              <div className="mt-5 flex flex-wrap gap-2">
                {f.pills.map(pill => (
                  <span
                    key={pill}
                    className="text-[12px] font-medium text-white/60 px-3 py-1 rounded-full"
                    style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)' }}
                  >
                    {pill}
                  </span>
                ))}
              </div>

              {/* Corner glow */}
              <div
                className="absolute -top-8 -right-8 w-32 h-32 rounded-full pointer-events-none"
                style={{ background: f.accent, filter: 'blur(30px)' }}
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Showcase;
